module.exports = __webpack_public_path__ + "static/media/playstation.89718af6.png";